(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("querySelector", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["querySelector"] = factory(require("vue"));
	else
		root["querySelector"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_43__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition